import { step1Routes } from './routes.step1.js';
import { step2Routes } from './routes.step2.js';
import { step3Routes } from './routes.step3.js';
import { step4Routes } from './routes.step4.js';
import { step5Routes } from './routes.step5.js';
import { step6Routes } from './routes.step6.js';
import { step7Routes } from './routes.step7.js';
import { step8Routes } from './routes.step8.js';
import { step9Routes } from './routes.step9.js';
import { step10Routes } from './routes.step10.js';
import { step11Routes } from './routes.step11.js';
import { actAsRoutes } from './routes.actas.js';
import { systemRoutes } from './routes.system.js';
import { historyRoutes } from './routes.history.js';
import { teamRoutes } from './routes.team.js';
export * from './common.js';
export * from './roles.js';
export * from './users.js';
export * from './me.js';
export * from './auth.js';
export * from './clients.js';
export * from './audit.js';
export * from './system.js';
export * from './route.js';
export * from './tasks.js';
export * from './work.js';
export * from './today.js';
export * from './requests.js';
export * from './timesheets.js';
export * from './holidays.js';
export * from './usage.js';
export * from './actas.js';
export * from './health.js';
export * from './engagement.js';
export * from './targets.js';
export * from './brief.js';
export * from './settings.js';
export * from './capture.js';
export * from './ideas.js';
export * from './checklists.js';
export * from './money.js';
export * from './meetings.js';
export * from './mail.js';
export * from './documents.js';
export * from './whatsapp.js';
export * from './llm.js';
export * from './history-import.js';
export * from './deck.js';
export * from './team.js';
export { step1Routes } from './routes.step1.js';
export { step2Routes } from './routes.step2.js';
export { step3Routes } from './routes.step3.js';
export { step4Routes } from './routes.step4.js';
export { step5Routes } from './routes.step5.js';
export { step6Routes } from './routes.step6.js';
export { step7Routes } from './routes.step7.js';
export { step8Routes } from './routes.step8.js';
export { step9Routes } from './routes.step9.js';
export { step10Routes } from './routes.step10.js';
export { step11Routes } from './routes.step11.js';
export { actAsRoutes } from './routes.actas.js';
export { systemRoutes } from './routes.system.js';
export { historyRoutes } from './routes.history.js';
export { teamRoutes } from './routes.team.js';
export const routes = {
    ...step1Routes,
    ...step2Routes,
    ...step3Routes,
    ...step4Routes,
    ...step5Routes,
    ...step6Routes,
    ...step7Routes,
    ...step8Routes,
    ...step9Routes,
    ...step10Routes,
    ...step11Routes,
    ...actAsRoutes,
    ...systemRoutes,
    ...historyRoutes,
    ...teamRoutes,
};
//# sourceMappingURL=index.js.map